import * as React from "react";
import * as Markdown from 'react-markdown';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

export const ExistingDataConflict = ({ configurationWarning }) => {
    const tooltip = <Tooltip id="tooltip" style={{ zIndex: 2500 }}>
        <Markdown>{configurationWarning}</Markdown>
    </Tooltip>

    return (
        <OverlayTrigger placement="top" overlay={tooltip}>
            <i className="text-warning fas fa-exclamation-triangle"></i>
        </OverlayTrigger>
    );
}
